import React from 'react'
import PageBlocks from '../cms-page-blocks/list'

const GenericSessionBlockEditor = (props) => {
  return (
    <PageBlocks
      title='Generic Session Sale Page Blocks'
      target='cms_fixed_page_blocks'
      cmsPageProp='page'
      cmsPageId='generic'
      route={props.route}
    />
  )
}

export default GenericSessionBlockEditor
